// components/Admin/MiniroomManager/BackgroundTable.jsx
import React from "react";
import {
    Table, TableBody, TableCell, TableHead, TableRow,
    IconButton, Chip, Avatar, Stack, Tooltip
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import api from "../../../api/axios";

const fitLabel = (v) => ({ cover: "Cover", contain: "Contain", stretch: "Stretch" }[v] ?? v);

export default function BackgroundTable({ items, refresh, onEdit }) {
    const onDelete = async (id) => {
        if (!window.confirm("삭제할까요?")) return;
        await api.delete(`/api/miniroom/admin/backgrounds/${id}/`);
        refresh?.();
    };

    return (
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell>미리보기</TableCell>
                    <TableCell>이름</TableCell>
                    <TableCell align="right">가격</TableCell>
                    <TableCell>판매</TableCell>
                    <TableCell>노출</TableCell>
                    <TableCell>무료</TableCell>
                    {/* ✅ 추가된 컬럼 */}
                    <TableCell>Fit</TableCell>
                    <TableCell>Scale</TableCell>
                    <TableCell>Offset</TableCell>
                    <TableCell align="right">액션</TableCell>
                </TableRow>
            </TableHead>

            <TableBody>
                {items.map((b) => (
                    <TableRow key={b.id}>
                        <TableCell>
                            <Avatar variant="square" src={b.image_url} sx={{ width: 48, height: 48 }} />
                        </TableCell>
                        <TableCell>{b.name}</TableCell>
                        <TableCell align="right">{b.price?.toLocaleString?.() ?? b.price}</TableCell>

                        <TableCell>
                            {b.is_unlimited ? (
                                <Chip size="small" label="무제한" color="primary" />
                            ) : (
                                <Chip size="small" label={`재고 ${b.stock}`} />
                            )}
                        </TableCell>

                        <TableCell>
                            <Chip size="small" color={b.is_active ? "primary" : "default"} label={b.is_active ? "on" : "off"} />
                        </TableCell>

                        <TableCell>
                            <Chip size="small" color={b.is_free ? "success" : "default"} label={b.is_free ? "free" : "paid"} />
                        </TableCell>

                        {/* ✅ 추가된 값 표기 */}
                        <TableCell>{fitLabel(b.fit_mode)}</TableCell>
                        <TableCell>{Math.round((b.scale ?? 1) * 100)}%</TableCell>
                        <TableCell>{b.offset_x ?? 0}, {b.offset_y ?? 0}</TableCell>

                        <TableCell align="right">
                            <Stack direction="row" spacing={1} justifyContent="flex-end">
                                <Tooltip title="수정">
                                    <IconButton size="small" onClick={() => onEdit?.(b)}>
                                        <EditIcon fontSize="inherit" />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="삭제">
                                    <IconButton size="small" onClick={() => onDelete(b.id)}>
                                        <DeleteIcon fontSize="inherit" />
                                    </IconButton>
                                </Tooltip>
                            </Stack>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}
